import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/data-element'
const plural = 'dataelements'
const single = 'dataelement'

const dataElements = new ApiCore({
	index: true,
	findOne: false,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

dataElements.massUpdate = () => {
	// Custom API Logic
}

dataElements.getDataElementTemplate = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then((resp) => {
			const response = handleResponse(resp)[1];

			let elementSchema = response?.elementSchema;
			let required = [...(elementSchema?.required ?? [])];

			// check if property is anyOf/oneOf (only check for index 0)
			let keys = ['anyOf', 'oneOf']
			for (let key of keys) {
				if (Array.isArray(elementSchema?.[key]) && elementSchema?.[key]?.length) {
					elementSchema = elementSchema?.[key]?.[0]
					required = [...required, ...(elementSchema?.required ?? [])];
				}
			}

			for (const p in elementSchema?.properties) {
				const deProp = elementSchema.properties?.[p];
				if (deProp?.items?.required) {
					required = [...required, ...deProp.items.required];
				}
			}

			required.forEach((prop) => {
				if (response.csvTemplate.includes(prop)) {
					response.csvTemplate = response.csvTemplate.replace(new RegExp(`\\b${prop}\\b,`, "g"), `${prop}*,`).replace(new RegExp(`\\b${prop}\\b\n`, "g"), `${prop}*\n`)
				}
			});
			return [undefined, response]
		})
		.catch(handleError);
}

export default dataElements
